export default "__VITE_ASSET__D8e32hff__"